
import { getStoreList, getInvitationList, acceptInvitation, unbindStore, rejectInvitation, StoreItem } from '@/api/store';
import { Component, Mixins } from 'vue-property-decorator'
import scroll from '@/mixins/scroll'
import { checkUnbindable } from '@/api/creatCompany'
import DisbindConfirm from '../selectStore/disbindConfirm.vue' // 注意相对路径修改
import { LoginReturnDataDto } from '@/utils/h5ToApp';
import { Getter, Action } from 'vuex-class';
import { Debounce } from '@/core/decorator';

@Component({
  name: 'DisBindStore',
  components: {
    DisbindConfirm,
  }
})
export default class DisBindStore extends Mixins(scroll) {

  @Getter info!: LoginReturnDataDto
  @Getter userId!: string
  @Getter mobile!: string
  @Getter multiStoreList!: (string | number)[]
  @Getter companyId!: string
  @Action setUserId!: (userId: string) => void

  isShowBack = true

  // 店铺邀请列表
  invitationList: StoreItem[] = []

  // 店铺列表
  storeList: StoreItem[] = []

  // 计算属性：我创建的店铺
  get myCreatedStores() {
    return this.storeList.filter(store => store.userOtherType === 1)
  }

  // 计算属性：我加入的店铺
  get myJoinedStores() {
    return this.storeList.filter(store => [0,2].includes(store.userOtherType))
  }

  // 是否显示解绑弹窗
  showDisbindDialog = false

  // 当前要解绑的店铺
  currentDisbindStore: any = { }

  created() {
    this.initPage()
  }

  initPage() {
    console.log('DisBindStore created')
    this.isShowBack = true
    Promise.all([this.getStoreList(), this.getInvitationList()])
  }

  async getStoreList() {
    try {
      const res = await getStoreList({
        registMobile: this.mobile
      })
      this.storeList = res.data.map(item => ({
        storeHeadPortrait: item.storeHeadPortrait,
        ...item
      }))
    } catch (err) {
      console.log('err', err)
    }
  }

  async getInvitationList() {
    try {
      const res = await getInvitationList({
        registMobile: this.mobile
      })
      this.invitationList = res.data.map(item => ({
        companyId: item.companyId,
        storeName: item.storeName,
        companyName: item.companyName,
        storeHeadPortrait: item.storeHeadPortrait
      }))
    } catch (err) {
      console.log('err', err)
    }
  }

  toCreateStore() {
    // 清除之前的表单缓存和图片缓存，确保是新的开始
    sessionStorage.removeItem('createStoreFormCache')
    sessionStorage.removeItem('editedStoreIcon')
    sessionStorage.removeItem('autoGeneratedStoreIcon')
    
    this.$router.push({
      path: '/createStore'
    })
  }
  
  onJoinStore() {
    this.$router.push('/joinStore')
  }

  // 处理邀请
  @Debounce(500)
  async acceptInvitation(item: StoreItem) {
    try {
      // 模拟接口调用
      const res = await acceptInvitation({
        registMobile: this.mobile,
        companyId: item.companyId
      })
      if (res.code === '000000') {
        this.$toast.clear()
        this.$toast.success(`同意了 ${item.storeName} 的邀请`);
        await this.getInvitationList();
        await this.getStoreList();
      } else {
        this.$toast.clear()
        this.$toast.fail(res.msg || '同意邀请失败');
      }
    } catch (error) {
      this.$toast.clear()
      this.$toast.fail(error.data.msg || '同意邀请失败');
    }
  }

  @Debounce(500)
  async rejectInvitation(item: StoreItem) {
    try {
      const res = await rejectInvitation({
        companyId: item.companyId,
        registMobile: this.mobile,
      })
      if (res.code === '000000') {
        this.$toast.clear()
        this.$toast.success(`拒绝了 ${item.storeName} 的邀请`);
        await this.getInvitationList();
      } else {
        this.$toast.clear()
        this.$toast.fail(res.msg || '拒绝邀请失败');
      }
    } catch (error) {
      this.$toast.clear()
      this.$toast.fail(error.data.msg || '拒绝邀请失败');
    }
  }
  
  // 解绑店铺
  onDisbindStore(store: StoreItem) {
    this.currentDisbindStore = store
    this.showDisbindDialog = true
  }

  // 取消解绑
  onCancelDisbind() {
    console.log('取消解绑')
    // 组件内部已经关闭了弹窗，这里只需要处理其他逻辑
  }

  // 确认解绑
  @Debounce(500)
  async onConfirmDisbind(storeData: StoreItem) {
    
    // 显示加载提示
    this.$toast({
      message: '解绑中...',
      duration: 0
    })

      try {
        // 调用解绑接口
        const res = await unbindStore({
          registMobile: this.mobile,
          companyId: storeData.companyId,
        })
        if (res.code === '000000') {
          this.$toast.clear()
          this.$toast.success('解绑成功')
          // 解绑后的处理逻辑
          const unbindCompanyId = storeData.companyId
          const isCurrentStore = unbindCompanyId === this.companyId
          const isInMultiStore = Array.isArray(this.multiStoreList) && this.multiStoreList.includes(unbindCompanyId)

          // 封装替换当前页面并隐藏返回按钮的行为
          const replaceCurrentPage = () => {
            this.$router.replace({
              path: '/selectStore',
              query: {
                from: 'disBindStore'
              }
            })
          }

          if (isCurrentStore) {
            this.setUserId(this.$store.state.user.firstUserId)
            this.$store.dispatch('GetInfo', {
              ...this.info,
              userId: this.$store.state.user.firstUserId,
              companyId: '',
            })
            replaceCurrentPage()
            return
          }

          if (isInMultiStore) {
            const newList = this.multiStoreList.filter(id => id !== unbindCompanyId)
            this.$store.commit('SET_MULTI_STORE_LIST', newList)
            if (this.multiStoreList.length === 1) {
              // 多店仅剩两个，解绑后只剩一个，刷新页面并隐藏返回
              replaceCurrentPage()
              return
            }
          }

          // 重新获取店铺列表
          this.getStoreList()
        } else {
          this.$toast.clear()
          this.$toast.fail(res.msg || '解绑失败')
        }
      } catch (e) {
      this.$toast.clear();
      this.$toast.fail(e.data.msg);
    }
  }

  // 进入个人中心
  toPersonalCenter() {
    this.$router.push('/PersonAccountCenter');
  }
}
